import { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";

// Horizontal bright red glowing katana slash dividing sections.
// Sweeps in once on scroll, then keeps a subtle glow travelling along the blade.
export default function SectionSlash() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px -15% 0px" });
  const reduced = useReducedMotion();
  const ease = [0.5, 0, 0.2, 1];

  return (
    <div
      ref={ref}
      data-testid="section-slash"
      aria-hidden="true"
      className="relative z-[15] h-0"
    >
      <div className="pointer-events-none absolute inset-x-0 -top-px flex items-center justify-center overflow-hidden">
        <motion.span
          initial={reduced ? { scaleX: 1, opacity: 1 } : { scaleX: 0, opacity: 0 }}
          animate={inView || reduced ? { scaleX: 1, opacity: 1 } : {}}
          transition={{ duration: 0.75, ease }}
          className="relative block h-[2px] w-full origin-left"
          style={{
            background: "linear-gradient(90deg, transparent, #ff1f1f 50%, transparent)",
            filter:
              "drop-shadow(0 0 18px rgba(255,40,40,0.9)) drop-shadow(0 0 6px rgba(255,80,80,0.85))",
          }}
        >
          {!reduced && (
            <>
              {/* subtle glow drifting along the blade */}
              <motion.span
                className="absolute top-1/2 h-[3px] w-[20%] -translate-y-1/2 rounded-full"
                style={{
                  background:
                    "radial-gradient(closest-side, rgba(255,130,130,0.95), rgba(255,40,40,0))",
                  filter: "blur(1px) drop-shadow(0 0 16px rgba(255,60,60,0.95))",
                }}
                initial={{ left: "-12%" }}
                animate={inView ? { left: ["-12%", "92%", "-12%"] } : {}}
                transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
              />
              {/* white-hot glint on the reveal sweep */}
              <motion.span
                initial={{ left: "0%", opacity: 0 }}
                animate={inView ? { left: "100%", opacity: [0, 1, 1, 0] } : {}}
                transition={{ duration: 0.75, ease }}
                className="absolute -top-[7px] h-[16px] w-[16px] -translate-x-1/2 rounded-full bg-white"
                style={{ boxShadow: "0 0 26px 11px rgba(255,55,55,0.9)" }}
              />
            </>
          )}
        </motion.span>
      </div>
    </div>
  );
}
